<template>
  <div class="work-page">
    <!-- 顶部操作栏 -->
    <el-card class="tool-card" shadow="never">
      <div class="tool-row">
        <div class="tool-left">
          <span class="tool-title">兼职表</span>
          <span class="tool-sub">登记外发兼职项目与价格，跟踪接单到结款进度</span>
        </div>
        <div class="tool-actions">
          <el-button icon="el-icon-view" @click="openPreview">预览</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openEdit(null)">新增兼职</el-button>
        </div>
      </div>
    </el-card>

    <!-- 列表 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="list"
        :header-cell-style="{ background: '#F7F9FC', color: '#18233C', fontWeight: 600 }"
        empty-text="暂无兼职记录"
      >
        <el-table-column prop="name" label="项目名称" min-width="180" />
        <el-table-column label="项目价格" width="130" align="right">
          <template slot-scope="{ row }">
            <span class="price-main">¥ {{ fmtMoney(row.price) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="项目状态" width="120" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusType(row.status)" size="small">{{ row.status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否显示" width="110" align="center">
          <template slot-scope="{ row }">
            {{ row.display_text }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="150">
          <template slot-scope="{ row }">
            <span class="time-text">{{ fmtDateTime(row.createtime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" align="center">
          <template slot-scope="{ row }">
            <el-button v-if="isCompany" type="text" size="small" @click="openEdit(row)">编辑</el-button>
            <el-button v-if="isCompany" type="text" size="small" class="del-btn" @click="doDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="editId ? '编辑兼职' : '新建兼职'" :visible.sync="editVisible" width="520px">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small">
        <el-form-item label="项目名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入项目名称（收款平台/项目）" :maxlength="50" />
        </el-form-item>
        <el-form-item label="项目价格" prop="price">
          <el-input-number v-model="form.price" :min="0" :max="99999999" :precision="2" :step="10" style="width: 100%" />
        </el-form-item>
        <el-form-item label="项目状态">
          <el-select v-model="form.status" style="width: 100%">
            <el-option label="接单中" :value="1" />
            <el-option label="待交稿" :value="2" />
            <el-option label="待审核" :value="3" />
            <el-option label="已打款" :value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否显示">
          <el-switch v-model="form.display" active-text="显示" inactive-text="不显示" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 预览设置弹窗 -->
    <el-dialog title="预览设置" :visible.sync="previewVisible" width="520px">
      <el-form label-width="100px" size="small">
        <el-form-item label="表格标题">
          <el-input v-model="previewForm.title" :maxlength="30" />
        </el-form-item>
        <el-form-item label="显示统计">
          <el-switch v-model="previewForm.showNum" active-text="显示" inactive-text="不显示" />
        </el-form-item>
        <template v-if="previewForm.showNum">
          <el-form-item label="兼职单数">
            <el-input-number v-model="previewForm.totalNum" :min="0" :max="99999999" style="width: 200px" />
          </el-form-item>
          <el-form-item label="已审核">
            <el-input-number v-model="previewForm.indexNum" :min="0" :max="99999999" style="width: 200px" />
          </el-form-item>
        </template>
        <el-form-item label="显示列">
          <el-checkbox-group v-model="previewCols">
            <el-checkbox v-for="c in workCols" :key="c.key" :label="c.key">{{ c.label }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="previewVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="previewing" @click="doPreview">预览</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { workList, workSave, workDelete, workPreviewUrl } from '@/api/tool'

export default {
  name: 'WorkList',
  data() {
    return {
      list: [],
      loading: false,
      editVisible: false,
      editId: 0,
      saving: false,
      form: { name: '', price: 0, status: 1, display: true },
      rules: {
        name: [
          { required: true, message: '请填写项目名称', trigger: 'blur' },
          { max: 50, message: '最多 50 字', trigger: 'blur' }
        ],
        price: [{ required: true, message: '请设置项目价格', trigger: 'change' }]
      },
      // 预览设置
      previewVisible: false,
      previewing: false,
      previewForm: { title: '兼职单', showNum: true, totalNum: 0, indexNum: 0 },
      workCols: [
        { key: 'name', label: '项目名称' },
        { key: 'price', label: '项目价格' },
        { key: 'status_text', label: '项目状态' },
        { key: 'create_time', label: '发布时间' }
      ],
      previewCols: ['name', 'price', 'status_text', 'create_time']
    }
  },
  created() {
    this.load()
  },
  computed: {
    isCompany() {
      const u = this.$store.state.user
      return !!u && u.type === 'company'
    }
  },
  methods: {
    load() {
      this.loading = true
      workList()
        .then(data => { this.list = data.list || [] })
        .catch(() => { this.list = [] })
        .finally(() => { this.loading = false })
    },
    openPreview() {
      this.previewVisible = true
    },
    doPreview() {
      if (this.previewCols.length === 0) {
        this.$message.warning('请至少勾选一列')
        return
      }
      this.previewing = true
      workPreviewUrl({
        title: this.previewForm.title.trim() || '兼职单',
        showNum: this.previewForm.showNum ? 1 : 0,
        totalNum: this.previewForm.totalNum,
        indexNum: this.previewForm.indexNum,
        cols: this.previewCols
      })
        .then(data => {
          if (data.url) window.open(data.url, '_blank')
          this.previewVisible = false
        })
        .catch(() => {})
        .finally(() => { this.previewing = false })
    },
    statusType(s) {
      s = parseInt(s)
      if (s === 4) return 'success'
      if (s === 3) return 'warning'
      if (s === 2) return 'primary'
      return 'info'
    },
    fmtMoney(n) {
      return parseFloat(n || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    fmtDateTime(ts) {
      if (!ts) return '—'
      const d = new Date(parseInt(ts) * 1000)
      const p = n => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    },
    openEdit(row) {
      if (row) {
        this.editId = row.id
        this.form = {
          name: row.name,
          price: parseFloat(row.price) || 0,
          status: parseInt(row.status),
          display: parseInt(row.display) === 1
        }
      } else {
        this.editId = 0
        this.form = { name: '', price: 0, status: 1, display: true }
      }
      this.editVisible = true
    },
    doSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        workSave({
          id: this.editId,
          name: this.form.name.trim(),
          price: this.form.price,
          status: this.form.status,
          display: this.form.display ? 1 : 0
        })
          .then(() => {
            this.$message.success(this.editId ? '修改成功' : '新增成功')
            this.editVisible = false
            this.load()
          })
          .catch(() => {})
          .finally(() => { this.saving = false })
      })
    },
    doDelete(row) {
      this.$confirm(`确认删除兼职「${row.name}」？`, '删除记录', {
        confirmButtonText: '删 除',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        workDelete(row.id)
          .then(() => {
            this.$message.success('删除成功')
            this.load()
          })
          .catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.work-page { padding: 0; }
.tool-card { margin-bottom: 14px; border-radius: 10px; border: 1px solid #E5E9F2; }
.tool-row { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px; }
.tool-left { display: flex; align-items: baseline; gap: 12px; }
.tool-title { font-size: 15px; font-weight: 700; color: #18233C; }
.tool-sub { font-size: 12px; color: #8A94AD; }
.table-card { border-radius: 10px; border: 1px solid #E5E9F2; }
.price-main { font-size: 14px; font-weight: 700; color: #3668FC; }
.time-text { color: #8A94AD; font-size: 12px; }
.del-btn { color: #E5484D; }
::v-deep .el-button--primary { background: #3668FC; border-color: #3668FC; }
::v-deep .el-button--primary:hover,
::v-deep .el-button--primary:focus { background: #5B8DFF; border-color: #5B8DFF; }
::v-deep .el-table__row:hover > td { background: #F5F8FF !important; }
::v-deep .el-dialog { border-radius: 12px; }
</style>